function segment(window) {
  function check() {
    if (window.analytics) return true;
    window.console.warn('Segment not loaded.');
    return false;
  }

  function analytics(method, ...args) {
    try {
      if (check()) return window.analytics[method].call(null, ...args);
    } catch (e) {
      window.console.error(e);
    }
  }

  return {
    init(id, data, hash) {
      return analytics('identify', id, data, { Intercom: { user_hash: hash } });
    },

    page(...args) {
      return analytics('page', ...args);
    },

    identify(...args) {
      return analytics('identify', ...args);
    },

    track(...args) {
      return analytics('track', ...args);
    },
  };
}

const {
  init, page, identify, track,
} = segment(window);

export {
  segment, init, page, identify, track,
};
